exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".video-js-responsive-container.vjs-hd {\n    padding-top: 56.25%;\n}\n.video-js-responsive-container.vjs-sd {\n    padding-top: 75%;\n}\n.video-js-responsive-container {\n    width: 100%;\n    position: relative;\n}\n.video-js-responsive-container .video-js {\n    height: 100% !important; \n    width: 100% !important;\n    position: absolute;\n    top: 0;\n    left: 0;\n}\n\n#video {\n    width: 100%;\n    height: 100%;\n}\n\n.vjs-leapest.video-js {\n    color: #00ff00;\n  }\n  \n  /* Change the border of the big play button. */\n  .vjs-leapest .vjs-big-play-button {\n    border-color: #00ff00;\n  }\n  \n  /* Change the color of various \"bars\". */\n  .vjs-leapest .vjs-volume-level,\n  .vjs-leapest .vjs-play-progress,\n  .vjs-leapest .vjs-slider-bar {\n    background: #00ff00;\n  }\n\n  .vjs-brand-container-link > img {\n      width: 26 !important;\n      height: 26 !important;\n  }\n  ", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// ./src/app/core/components/evaluation/content/video/video.component.css
// module id = 783
// module chunks = 0